<template>
  <div :style="styleObject">
    <button
      style="display: none"
      type="button"
      class="btn-select-free-item-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalSelectFreeItem"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-hide-select-free-item-modal"
      data-bs-dismiss="modal"
      data-bs-target="#modalSelectFreeItem"
    ></button>
    <div
      class="modal fade"
      :class="{ 'mlx-free-item': theme2 }"
      id="modalSelectFreeItem"
      tabindex="-1"
      aria-labelledby="modalSelectFreeItemLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <!-- KSK035: kiosk theme 2 (P18). MOO (isKiosk=false) keeps the markup below unchanged. -->
      <KskModalShell v-if="isKiosk" :width="960" :show-close="false">
        <div class="ksk-fi">
          <div class="ksk-fi__top">
            <div class="ksk-fi__badge">
              <span class="material-icons-round">card_giftcard</span>
            </div>
            <button
              type="button"
              class="ksk-fi__close"
              :aria-label="$t('kiosk.common.close')"
              data-bs-dismiss="modal"
              @click="removeVoucherSelected"
            >
              <span class="material-icons-round">close</span>
            </button>
          </div>
          <h2 class="ksk-fi__title">{{ $t("kiosk.freeItem.title") }}</h2>
          <p class="ksk-fi__sub">
            <template v-if="rewardTitle">{{ rewardTitle + " • " }}</template>{{ $t("kiosk.freeItem.sub") }}
          </p>
          <div v-if="items.length > 0" class="ksk-fi__grid">
            <div
              v-for="(item, index) in items"
              :key="index"
              class="item-info ksk-fi__tile"
              :class="[
                'item-info-' + item.id,
                {
                  'ksk-fi__tile--on': itemSelected && itemSelected.id == item.id,
                  'ksk-fi__tile--off': !checkAvailableItem(item),
                },
              ]"
              @click="selectItem(item)"
            >
              <img :src="item.image" alt="" class="ksk-fi__img" />
              <div class="ksk-fi__info">
                <div class="ksk-fi__name">{{ tName(item.item_name) }}</div>
                <div v-if="item.description" class="ksk-fi__desc">
                  {{ item.description }}
                </div>
                <span v-if="checkAvailableItem(item)" class="ksk-fi__pill">{{ $t("kiosk.freeItem.free") }}</span>
                <span v-else class="ksk-fi__pill ksk-fi__pill--off">{{ $t("kiosk.common.notAvailable") }}</span>
              </div>
              <span class="ksk-fi__radio">
                <span
                  v-if="itemSelected && itemSelected.id == item.id"
                  class="material-icons-round"
                  >check</span
                >
              </span>
            </div>
          </div>
          <div v-else-if="!loaderActive" class="ksk-fi__empty">
            <span class="material-icons-round">redeem</span>
            {{ $t("kiosk.freeItem.empty") }}
          </div>
        </div>
        <template v-if="items.length > 0" #footer>
          <KskButton
            variant="muted"
            class="ksk-fi__cancel"
            data-bs-dismiss="modal"
            @click="removeVoucherSelected"
          >
            {{ $t("kiosk.common.cancel") }}
          </KskButton>
          <KskButton icon="redeem" class="ksk-fi__confirm" @click="confirmSelection">
            {{ $t(itemSelected ? "kiosk.freeItem.confirmSelected" : "kiosk.freeItem.confirm") }}
          </KskButton>
        </template>
      </KskModalShell>
      <div v-else class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header d-flex justify-content-between pt-2 pb-2">
            <div class="text-bold">Select a Free Item</div>
            <div
              class="btn-close-modal"
              data-bs-dismiss="modal"
              @click="removeVoucherSelected"
            >
              &times;
            </div>
          </div>
          <div class="modal-body">
            <div class="item-list" v-if="items.length > 0">
              <div
                class="item-info d-flex"
                :class="'item-info-' + item.id"
                v-for="(item, index) in items"
                :key="index"
                @click="selectItem(item)"
                :style="{ opacity: !checkAvailableItem(item) ? 0.5 : 1 }"
              >
                <div>
                  <img :src="item.image" alt="Error" class="item-image" />
                </div>
                <div>
                  <div class="item-name">
                    {{ item.item_name }}
                  </div>
                  <div class="item-description">
                    {{ item.description }}
                  </div>
                  <div v-if="!checkAvailableItem(item)" style="color: #eb2f06;font-size: 14px;width: 100%; margin-top: 5px;">NOT AVAILABLE</div>
                </div>
              </div>
            </div>
            <div class="text-center" v-else>
              <div class="text-bold">No items available!</div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-end" v-if="items.length > 0">
            <button
              type="button"
              class="btn-confirm-selection"
              @click="confirmSelection"
            >
              Confirm Selection
            </button>
          </div>
        </div>
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <div
      class="position-fixed top-1 end-1 z-index-2 message-success"
      style="z-index: 99999 !important"
    >
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import KskModalShell from "@/views/kiosk/components/ui/KskModalShell.vue";
import KskButton from "@/views/kiosk/components/ui/KskButton.vue";
import { collectNamesDeep, syncMenuTranslations, translatedName } from "@/i18n/menuTranslate";
import { localStorageName } from "@/config/utils";
import PromocodeService from "../services/promocode.service";
import $ from "jquery";

export default {
  name: "ModalSelectFreeItem",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    KskModalShell,
    KskButton,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    rewardId: {
      type: Number,
      required: true,
    },
    handleUseVoucher: {
      type: Function,
      required: true,
    },
    removeVoucherSelected: {
      type: Function,
      required: true,
    },
    isKiosk: {
      type: Boolean,
      default: false,
    },
    // KSK035: reward name shown under the kiosk popup title.
    rewardTitle: {
      type: String,
      default: "",
    },
    // MTH083: opt-in theme2 skin. Kiosk MyReward shares this component,
    // so the new look only applies where the caller asks for it.
    theme2: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loaderActive: false,
      snackbar: null,
      message: "",
      branch:
        JSON.parse(localStorage.getItem(localStorageName("BRANCH_INFO"))) ??
        null,
      memberInfo:
        JSON.parse(localStorage.getItem(localStorageName(this.isKiosk ? 'KIOSK_MEMBER_INFO' : "memberInfo"))) ??
        null,
      items: [],
      itemSelected: null,
      timeoutNotification: null,
    };
  },
  computed: {
    styleObject() {
      // Drive the popup off the merchant's Theme 2 colour (main_theme2_color),
      // matching MyReward.vue and the other reskinned screens; fall back to legacy.
      const base =
        this.$store.state.mainThemeColorTheme2 ||
        this.$store.state.color ||
        "#201a1a";
      return {
        "--color": base,
        "--mlx-btn": this.$store.state.primaryButtonColorTheme2 || base,
      };
    },
  },
  methods: {
    tName(source) {
      return translatedName(source);
    },
    getListFreeItem() {
      this.showLoader();

      let dataForm = {
        reward_id: this.rewardId,
        merchant_id: localStorage.getItem(localStorageName("MERCHANT_ID"), 0),
        branch_code: this.branch.branch_code ?? "",
        member_id: this.memberInfo.id ?? 0,
      };

      PromocodeService.getListFreeItem(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.items = response.data.data;
            // KSK054: free-item names are not part of the kiosk menu batch.
            if (this.isKiosk) syncMenuTranslations(collectNamesDeep(this.items));
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response.data.result.message;
          this.hideLoader();
        }
      );
    },

    selectItem(item) {
      if(this.checkAvailableItem(item)) {
        this.itemSelected = item;
        $(".item-info").removeClass("selected");
        $(`.item-info-${item.id}`).addClass("selected");
      }
    },

    confirmSelection() {
      this.snackbar = null;
      this.message = "";
      clearTimeout(this.timeoutNotification);
      this.timeoutNotification = null;

      if (this.itemSelected) {
        $(".btn-hide-select-free-item-modal").click();
        this.handleUseVoucher(this.itemSelected);
      } else {
        this.snackbar = "danger";
        this.message = this.isKiosk ? this.$t("kiosk.freeItem.selectOne") : "Please select an item!";
        this.setTimeOutNotification();
      }
    },

    checkAvailableItem(item) {
      if (item.stock_enable_balance) {
        // countdown = true
        if (item.stock_balance > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        // countdown = false
        if (item.is_not_available == 0) {
          return true;
        } else {
          return false;
        }
      }
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      this.timeoutNotification = setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },
  },
  watch: {
    keyReload() {
      this.items = [];
      this.itemSelected = null;
      this.getListFreeItem();
    },
  },
};
</script>

<style scoped>
.modal-body {
  max-height: 75vh;
  overflow-y: auto;
}

.btn-close-modal {
  font-size: 24px !important;
  font-weight: bold;
  cursor: pointer;
}

.btn-confirm-selection {
  border: 1px solid var(--color);
  background-color: var(--color);
  border-radius: 5px;
  color: #ffffff;
  padding: 5px 20px;
}

.item-info {
  margin-top: 5px;
  border: 2px solid #f1f1f1;
  border-radius: 5px;
  padding: 5px;
}

.item-info.selected {
  border: 2px solid var(--color);
}

.item-info .item-image {
  width: 70px;
  height: 70px;
}

.item-info .item-name {
  font-size: 14px;
  font-weight: bold;
  color: #000;
  width: 100%;
  display: -webkit-box !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-info .item-description {
  font-size: 11px;
  color: #666;
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── MTH083 — theme2 skin, opted in via the `theme2` prop (MOO MyReward only).
   Everything above stays untouched for the kiosk. Colours are derived from
   var(--color) (main_theme2_color) with color-mix tiers, matching the
   .moo-reward-page reskin, so the popup tracks each merchant's brand. ── */
.mlx-free-item {
  --fi-06: color-mix(in srgb, var(--color) 6%, #ffffff);
  --fi-12: color-mix(in srgb, var(--color) 12%, #ffffff);
  --fi-22: color-mix(in srgb, var(--color) 22%, #ffffff);
  --fi-muted: color-mix(in srgb, var(--color) 55%, #ffffff);
  font-family: "Plus Jakarta Sans", "Manrope", system-ui, sans-serif;
  /* Bootstrap writes inline padding-left/right on .modal to compensate for the
     scrollbar, which pushes the centred card off-axis. Reset both. */
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.mlx-free-item .modal-dialog {
  max-width: 24rem;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;
}

.mlx-free-item .modal-content {
  border: none;
  border-radius: 1.5rem;
  overflow: hidden;
  background: var(--fi-06);
  box-shadow: 0 20px 40px rgba(25, 28, 30, 0.18);
}

/* Header — solid brand band */
.mlx-free-item .modal-header {
  align-items: center;
  border-bottom: none;
  background: var(--color);
  padding: 1rem 1.25rem !important;
}

.mlx-free-item .modal-header .text-bold {
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: #ffffff;
}

.mlx-free-item .btn-close-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  font-size: 20px !important;
  line-height: 1;
}

/* Body */
.mlx-free-item .modal-body {
  padding: 1rem 1.25rem 0.5rem;
  max-height: 60vh;
}

.mlx-free-item .item-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.mlx-free-item .item-info {
  align-items: center;
  gap: 0.85rem;
  margin-top: 0;
  padding: 0.75rem;
  border: 1px solid var(--fi-22);
  border-radius: 1rem;
  background: #ffffff;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease,
    transform 0.15s ease;
}

.mlx-free-item .item-info:active {
  transform: scale(0.99);
}

.mlx-free-item .item-info.selected {
  border: 2px solid var(--color);
  background: var(--fi-12);
  padding: calc(0.75rem - 1px);
}

.mlx-free-item .item-info .item-image {
  width: 60px;
  height: 60px;
  border-radius: 0.75rem;
  object-fit: cover;
}

.mlx-free-item .item-info .item-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: #1a1717;
}

.mlx-free-item .item-info .item-description {
  font-size: 0.75rem;
  font-weight: 500;
  color: #6b6868;
}

.mlx-free-item .modal-body .text-bold {
  padding: 2rem 1rem;
  font-weight: 600;
  color: var(--fi-muted);
}

/* Footer — full-width pill CTA */
.mlx-free-item .modal-footer {
  border-top: none;
  padding: 0.5rem 1.25rem 1.25rem;
}

.mlx-free-item .btn-confirm-selection {
  width: 100%;
  border: none;
  border-radius: 9999px;
  background-color: var(--mlx-btn, var(--color));
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: 700;
  padding: 0.8rem 1rem;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.mlx-free-item .btn-confirm-selection:active {
  transform: scale(0.97);
}

/* ── KSK035 — P18 kiosk free-item picker (theme 2), isKiosk only.
   Tiles keep the `item-info` class for the jQuery `.selected` toggle, so the
   legacy `.item-info` rules above are overridden with higher specificity. ── */
.ksk-fi__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ksk-fi__badge {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ksk-primary);
  color: var(--ksk-on-primary);
}
.ksk-fi__badge .material-icons-round {
  font-size: 38px;
}
.ksk-fi__close {
  width: 64px;
  height: 64px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ksk-surface-muted);
  color: var(--ksk-text);
  cursor: pointer;
  transition: transform 80ms ease-out;
}
.ksk-fi__close .material-icons-round {
  font-size: 32px;
}
.ksk-fi__close:active {
  transform: scale(0.95);
}
.ksk-fi__title {
  margin: var(--ksk-space-3) 0 0;
  font-family: var(--ksk-font);
  font-size: var(--ksk-headline-size);
  line-height: var(--ksk-headline-lh);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--ksk-text);
}
.ksk-fi__sub {
  margin: 4px 0 0;
  font-size: var(--ksk-body-size);
  line-height: var(--ksk-body-lh);
  color: var(--ksk-text-secondary);
}
.ksk-fi__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--ksk-gutter);
  margin-top: var(--ksk-space-4);
  max-height: 864px;
  overflow-y: auto;
  /* keep the 3px selected ring from being clipped by the scroll box */
  padding: 3px;
  margin-left: -3px;
  margin-right: -3px;
}
.ksk-fi__tile.item-info {
  display: flex;
  align-items: center;
  gap: var(--ksk-space-2);
  height: 168px;
  margin: 0;
  padding: var(--ksk-space-2);
  border: none;
  border-radius: var(--ksk-radius-card);
  background: var(--ksk-surface);
  box-shadow: inset 0 0 0 2px var(--ksk-border), var(--ksk-shadow-card);
  cursor: pointer;
  transition: transform 80ms ease-out, background-color 80ms ease-out;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}
.ksk-fi__tile.item-info:active {
  transform: scale(0.99);
}
.ksk-fi__tile.item-info.ksk-fi__tile--on {
  background: var(--ksk-primary-container);
  box-shadow: inset 0 0 0 3px var(--ksk-primary), var(--ksk-shadow-card);
}
.ksk-fi__tile.item-info.ksk-fi__tile--off {
  opacity: 0.5;
  cursor: default;
}
.ksk-fi__img {
  width: 110px;
  height: 110px;
  flex: none;
  border-radius: 16px;
  object-fit: cover;
  background: var(--ksk-surface-muted);
}
.ksk-fi__info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.ksk-fi__name {
  width: 100%;
  font-size: var(--ksk-label-size);
  line-height: var(--ksk-label-lh);
  font-weight: 600;
  color: var(--ksk-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ksk-fi__tile--on .ksk-fi__name {
  color: var(--ksk-primary);
}
.ksk-fi__desc {
  width: 100%;
  margin-top: 2px;
  font-size: var(--ksk-caption-size);
  line-height: var(--ksk-caption-lh);
  color: var(--ksk-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ksk-fi__pill {
  margin-top: var(--ksk-space-1);
  padding: 2px 10px;
  border-radius: 8px;
  font-size: var(--ksk-caption-size);
  line-height: var(--ksk-caption-lh);
  font-weight: 700;
  letter-spacing: 0.02em;
  background: var(--ksk-surface-muted);
  color: var(--ksk-text-secondary);
}
.ksk-fi__tile--on .ksk-fi__pill {
  background: var(--ksk-primary);
  color: var(--ksk-on-primary);
}
.ksk-fi__pill--off {
  background: color-mix(in srgb, var(--ksk-error) 12%, #ffffff);
  color: var(--ksk-error);
}
.ksk-fi__radio {
  width: 44px;
  height: 44px;
  flex: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ksk-surface-muted);
}
.ksk-fi__radio::before {
  content: "";
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--ksk-surface);
}
.ksk-fi__tile--on .ksk-fi__radio {
  background: var(--ksk-primary);
  color: var(--ksk-on-primary);
}
.ksk-fi__tile--on .ksk-fi__radio::before {
  display: none;
}
.ksk-fi__radio .material-icons-round {
  font-size: 28px;
  font-weight: 700;
}
.ksk-fi__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--ksk-space-1);
  padding: var(--ksk-space-6) 0 var(--ksk-space-3);
  font-size: var(--ksk-body-size);
  font-weight: 600;
  color: var(--ksk-text-secondary);
}
.ksk-fi__empty .material-icons-round {
  font-size: 64px;
}
.ksk-fi__cancel {
  flex: 0 0 260px;
}
/* KskModalShell's `footer > * { flex: 1 }` is scoped to the shell, so it
   misses slotted buttons; stretch the CTA here. */
.ksk-fi__confirm {
  flex: 1;
}
</style>
